import React, { useState } from 'react';
import { generateMeetingPrep } from '../../services/factFinderApi';

function MeetingPrepPanel({ caseData }) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleGenerate() {
    setLoading(true);
    setError('');
    try {
      const res = await generateMeetingPrep(caseData);
      if (res.success) {
        setResult(res);
      } else {
        setError(res.error || 'Meeting prep generation failed.');
      }
    } catch (err) {
      setError(err.message || 'Meeting prep generation failed.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ff-card ff-p4-panel" data-testid="meeting-prep-panel">
      <div className="ff-p4-header">
        <div>
          <h3>Meeting Prep Mode</h3>
          <p className="ff-card-description">
            Get a complete preparation guide for your upcoming meeting.
          </p>
        </div>
        <button
          className="ff-btn-primary ff-btn-sm"
          onClick={handleGenerate}
          disabled={loading}
          data-testid="generate-prep-btn"
        >
          {loading ? 'Generating...' : 'Generate Prep'}
        </button>
      </div>

      {error && <div className="ff-inline-error">{error}</div>}

      {result && (
        <div className="ff-p4-result" data-testid="meeting-prep-result">
          {/* Opening Posture */}
          {result.opening_posture && (
            <div className="ff-prep-section ff-prep-highlight">
              <h4>Opening Posture</h4>
              <p>{result.opening_posture}</p>
            </div>
          )}

          {/* Likely Questions */}
          {result.likely_questions?.length > 0 && (
            <div className="ff-prep-section">
              <h4>Likely Questions Management Will Ask</h4>
              <div className="ff-prep-questions">
                {result.likely_questions.map((q, idx) => (
                  <div key={idx} className="ff-prep-q-item" data-testid={`prep-question-${idx}`}>
                    <div className="ff-prep-q-text">{q.question}</div>
                    <div className="ff-prep-q-safe">
                      <strong>Safe approach:</strong> {q.safe_answer_approach}
                    </div>
                    <div className="ff-prep-q-avoid">
                      <strong>Do not say:</strong> {q.what_not_to_say}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Safe Phrasing */}
          {result.safe_phrasing?.length > 0 && (
            <div className="ff-prep-section">
              <h4>Safe Phrasing Guide</h4>
              <div className="ff-phrasing-grid">
                {result.safe_phrasing.map((p, idx) => (
                  <div key={idx} className="ff-phrasing-item" data-testid={`phrasing-${idx}`}>
                    <div className="ff-phrasing-situation">{p.situation}</div>
                    <div className="ff-phrasing-do">
                      <span className="ff-phrasing-label ff-label-good">Say this</span>
                      {p.say_this}
                    </div>
                    <div className="ff-phrasing-dont">
                      <span className="ff-phrasing-label ff-label-bad">Not this</span>
                      {p.not_this}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Do Not Volunteer */}
          {result.do_not_volunteer?.length > 0 && (
            <div className="ff-prep-section ff-prep-warning">
              <h4>Do Not Volunteer</h4>
              <ul>
                {result.do_not_volunteer.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Documents to Bring */}
          {result.documents_to_bring?.length > 0 && (
            <div className="ff-prep-section">
              <h4>Documents to Bring</h4>
              <div className="ff-docs-list">
                {result.documents_to_bring.map((doc, idx) => (
                  <div key={idx} className="ff-doc-item" data-testid={`doc-${idx}`}>
                    <div className="ff-doc-name">{doc.document}</div>
                    <div className="ff-doc-why">{doc.why}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Clarifying Questions */}
          {result.clarifying_questions_to_ask?.length > 0 && (
            <div className="ff-prep-section">
              <h4>Questions to Ask Management</h4>
              <ul>
                {result.clarifying_questions_to_ask.map((q, idx) => (
                  <li key={idx}>{q}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Closing Notes */}
          {result.closing_notes && (
            <div className="ff-prep-section ff-prep-highlight">
              <h4>Closing the Meeting</h4>
              <p>{result.closing_notes}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MeetingPrepPanel;
